import {getPartImageColumn} from './columnDefinition'

export const getControlColumns = (getClass) => {
  return [
    getPartImageColumn(getClass),
  ]
}
